module.exports = __webpack_public_path__ + "img/sharsheret_yes.f3e020cf.png";